import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import { APIContext } from '../../Contexts/APIContext';
import { useContext, useState } from 'react';
import OfflineAuthViewModel from './ViewModels/OfflineAuthViewModel';
import TextField from '@mui/material/TextField';
import Line from '../../Utilities/Line';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

interface IProps {
    open: boolean;
    close: () => void;
}

export default function OfflineAuthDialog(props: IProps) {
    const { get } = useContext(APIContext);
    const [licenceNumber, setLicenceNumber] = useState<string>('');
    const [data, setData] = useState<OfflineAuthViewModel | null>(null);

    const closeDialog = () => {
        props.close();
        setLicenceNumber('');
        setData(null);
    }
    const searchLicenceNumber = () => {
        get('Organisation', `GetOfflineAuthData?licenceNumber=${licenceNumber}`, setData);
    }
    const updateLicenceNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLicenceNumber(event.target.value);
    }
    const generateAuthKey = () => {
        if (data) {
            get('Organisation', `GenerateOfflineAuthKey?licenceString=${data.licenceNumber}&softwareRef=${data.softwareRef}`, searchLicenceNumber);
        }
    }
    const updateSoftwareRef = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (data) {
            setData({ ...data, softwareRef: event.target.value });
        }
    }
    const clearSoftwareRef = () => {
        if (data) {
            setData({ ...data, softwareRef: '' });
        }
    }


    return (
        <Dialog
            open={props.open}
            onClose={closeDialog}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Offline System Authentication</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid size={6}>
                        <TextField label="Licence Number" value={licenceNumber} onChange={updateLicenceNumber} />
                    </Grid>
                    <Grid size={6}>
                        <Button variant="contained" onClick={searchLicenceNumber}>Search</Button>
                    </Grid>
                    <Line />
                    {data ?
                        <>
                            <Grid size={12}>
                                <Typography variant="h6">{data.organisationName} - {data.siteName}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography variant="body1">Licence Number: {data.licenceNumber}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    label="Software Reference Number"
                                    value={data.softwareRef}
                                    onChange={updateSoftwareRef}
                                    InputProps={{
                                        endAdornment: data.softwareRef ? (
                                            <IconButton size="small" onClick={clearSoftwareRef}>
                                                <ClearIcon />
                                            </IconButton>
                                        ) : undefined
                                    }} />
                            </Grid>
                            <Grid size={12}>
                                <Typography variant="body1">Offline Authentication Key: {data.authKey}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Button variant="contained" onClick={generateAuthKey} disabled={!(data.softwareRefSkip || data.softwareRef.length > 0)}>Generate Authentication Key</Button>
                            </Grid>
                        </>
                        :
                        <Grid size={12}>
                            <Typography variant="body1">Please search for a licence number</Typography>
                        </Grid>
                    }
                    <Grid size={12}>
                        <Button onClick={closeDialog}>Close</Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog >
    );
}